<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row justify="center">
          <v-col cols="12">
            <div class="text-center text-h4">{{welcomeText}}</div>
            <div class="text-center text-subtitle-2">{{desc}}</div>
            <div class="text-center text-subtitle-2" v-if="!bracketFinished">Bracket {{bracketRound + 1}}</div>
            <div class="text-center text-subtitle-2" v-if="!bracketFinished">Round {{currentIndex + 1}}</div>
            <div class="text-center text-subtitle-2" v-if="bracketFinished">Bracket Winner</div>
          </v-col>
        </v-row>

        <v-row justify="space-around" v-if="!bracketFinished">
          <v-col cols="6" v-for="faceOff in shuffledOptions[currentIndex]">
              <v-card
              @click="addToBracket(faceOff)"
              max-width="344"
              class="mx-auto"
            >
              <v-list-item>
                <v-list-item-content class="text-center">
                  <v-list-item-title class="text-subtitle-1">{{faceOff.name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
          
              <v-img
                :src="faceOff.src"
                height="50vh"
                contain
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center" v-if="bracketFinished">
          <v-col cols="6">
              <v-card
              max-width="344"
              class="mx-auto"
            >
              <v-list-item>
                <v-list-item-content class="text-center">
                  <v-list-item-title class="text-subtitle-1">{{winner.name}}</v-list-item-title>
                  <a class="text-subtitle-1" :href="winnerURL" target="_blank">Start Fapping</a>
                </v-list-item-content>
              </v-list-item>
          
              <v-img
                :src="winner.src"
                height="50vh"
                contain
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
        export default {
        name: 'BracketTemplate',
        props: {
          welcomeText : String,
          desc: String,
          options: Array,
        },
        data: () => ({
          shuffledOptions: [],
          currentIndex: 0,
          bracketIndex: 0,
          bracketRound: 0,
          bracketArray: [],
          bracketFinished: false,
          winner: {},
          winnerURL: ''
        }),
        mounted() {
          this.shuffledOptions = this.randChunkSplit(this.shuffle(this.options), 2)
        },
        methods: {
          shuffle: function(array){
            for (let i = array.length - 1; i > 0; i--) {
              let j = Math.floor(Math.random() * (i + 1));
              [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
          },
          randChunkSplit: function(arr,min,max) {
            // uncomment this line if you don't want the original array to be affected
            // var arr = arr.slice();
            var arrs = [],size=1; 
            var min=min||1;
            var max=max||min||1;
            while (arr.length > 0) {
              size = Math.min(max,Math.floor((Math.random()*max)+min));
              arrs.push(arr.splice(0, size));
            }
            return arrs;
          },
          addToBracket(option) {
            console.log(this.shuffledOptions.length);
            if(this.shuffledOptions.length == 1){
              this.winner = option;
              this.winnerURL = 'https://www.pichunter.com/search/' + this.winner.name.split(' ').join('%20');
              this.bracketFinished = true;
            } else{
              if(!this.bracketArray[this.bracketIndex]){
                this.bracketArray[this.bracketIndex] = [option];
              } else if(this.bracketArray[this.bracketIndex].length == 1){
                this.bracketArray[this.bracketIndex].push(option);
              } else {
                this.bracketArray[this.bracketIndex + 1] = [option];
                this.bracketIndex++;
              }
              this.currentIndex++;
              if(this.currentIndex == (this.shuffledOptions.length)){
                this.shuffledOptions = this.bracketArray;
                this.currentIndex = 0;
                this.bracketIndex = 0;
                this.bracketRound++;
                this.bracketArray = [];
              }
            }
          }
        },
      }
</script>